let exportJQuery = null;

if (typeof window !== 'undefined') {
  const $ = require('jquery');
  (<any>window).jQuery = $;
  (<any>window).$ = $;

  exportJQuery = (<any>window).jQuery;
}

export default <JQueryStatic>exportJQuery;
